<template>
  <b-container class="topheader"
               fluid
               :class="{ 'fixed' : isScroll }">
    <b-row id="topbar">
      <!-- Sidebar toggler -->
      <a role="button"
         v-if="!hideToggle"
         @click="toggleSidebar"
         :class="isHidden ? 'sidebar-toggler' : 'sidebar-toggler fold'">
      </a>
      <!-- /Sidebar toggler -->

      <b-col class="d-flex align-items-center justify-content-start px-0 py-1">
        <!-- User info -->
        <div v-click-outside="closeUserInfoMenuPopOver">
        <span class="user-info-area"
              @click="showUserInfoMenu()">

          <!-- Profile image -->
          <span class="user-profile">
            <!-- Custom image -->
            <img v-if="currentUser.profileImg && currentUser.profileImg !== ''"
                 :src="'data:image/' + currentUser.profileImgName.substr(currentUser.profileImgName.lastIndexOf('.')) + ';base64,' + currentUser.profileImg"
                 alt="user profile">
            <!-- /Custom image -->
            <!-- Default image -->
            <img v-else
                 src="../assets/images/icon_user.png"
                 alt="user profile">
            <!-- /Default image -->
          </span>
          <!-- /Profile image -->

          <!-- User ID -->
					<a href="#"
             style=""
             class="user-detail">{{ currentUser.userkorname +" (" + currentUser.caller + ")"}}</a>
          <!-- /User ID -->

          <!-- User info dropdown menu -->
          <span class="info-menu-area">
            <button type="button"
                    class="btn-user-info"></button>
            <div class="user-info-menu"
                 v-if="!isShowUserInfoMenu">
              <span class="menu">
                <!-- Settings -->
                <a role="button"
                   @click="showUserDetail()">Setting</a>
                <!-- /Settings -->
              </span>
              <span class="menu">
                <!-- Sign out -->
                <div id="sign">
                  <a role="button"
                     @click="goSign"
                     class="">{{ showSign() }}</a>
                </div>
                <!-- /Sign out -->
              </span>
            </div>
          </span>
          <!-- /User info dropdown menu -->
        </span>
        </div>
        <!-- /User info -->

        <!-- Navigation -->
        <div class="d-flex align-items-center"
             v-if="currentUser">
          <b-badge @click="redirect($event)"
                   class="btn badge-project mr-1"
                   v-for="role in roles()"
                   :key="role">{{ role }}
          </b-badge>
        </div>
        <!-- /Navigation -->
      </b-col>

      <!-- 매뉴얼 아이콘 영역 -->
      <div class="manual">
        <button>
          <img :src="require('@/assets/images/manual.png')"  @click="showUserManual">
        </button>
      </div>
      <!-- 알림 영역 -->
      <div class="notify-wrap">
        <div class="notify-area"
             @click="openNotiPopover"
             v-click-outside="closeNotiPopOver"
             :class="{ 'active' : notiPopoverVisible }">
          <button type="button"
                  class="btn-notify"
                  :class="{ 'alert' : notificationExists }"
                  ></button>
          <span><strong>{{ notificationCount }}</strong></span>
        </div>
        <div class="notify-contents-wrap all-noti"
             v-if="notiPopoverVisible">
          <div class="notify-contents-area notify-custom-scrollbar">
            <div class="notify-contents"
                 :class="{ 'no-notify': !notificationExists }">
              <!-- <div class="title">Creator</div> -->
              <div class="notify-box">
                <div class="box-area" v-for="chat in chatList" :key="chat.chatId">
                  <div class="tag"
                        :class="convertStatusToKebabCase(chat.status)">
                    {{ convertStatusToTitleCase(chat.status) }}
                  </div>
                  <router-link :to="`/chatter/edit/${chat.chatId}`"
                      class="text-wrap">
                    <div class="subject-wrap">
                      <div class="code">{{ chat.chatId }}</div>
                      <div class="subject">{{ chat.title }}</div>
                    </div>
                    <!-- 2023-09-14 김영현 : 업데이트 날짜를 기본으로 표기, 없다면 생성날짜 표기-->
                    <div class="date">{{ chat.updatedDate == '-' ? chat.creationDate : chat.updatedDate }}</div>
                  </router-link>
                </div>
              </div>
              <!-- 알림 내용 없는 경우 -->
              <div class="text-wrap"
                   v-if="!notificationExists">
                <svg xmlns="http://www.w3.org/2000/svg"
                     width="24"
                     height="24"
                     viewBox="0 0 24 24"
                     fill="none">
                  <g opacity="0.5">
                    <path d="M15 17H9V18C9 19.6569 10.3431 21 12 21C13.6569 21 15 19.6569 15 18V17Z"
                          fill="#2E2E38"/>
                    <path d="M5 17H19C19.5523 17 20 16.5523 20 16V15.4142C20 15.149 19.8946 14.8947 19.7071 14.7071L19.1963 14.1963C19.0706 14.0706 19 13.9001 19 13.7224V10C19 6.134 15.866 2.99999 12 3C8.134 3.00001 5 6.13401 5 10V13.7224C5 13.9002 4.9294 14.0706 4.80372 14.1963L4.29289 14.7071C4.10536 14.8947 4 15.149 4 15.4142V16C4 16.5523 4.44772 17 5 17Z"
                          stroke="#2E2E38"
                          stroke-width="1.5"
                          stroke-linecap="round"
                          stroke-linejoin="round"/>
                    <path d="M10 12L14 8"
                          stroke="#2E2E38"
                          stroke-width="1.4"
                          stroke-linecap="round"
                          stroke-linejoin="round"/>
                    <path d="M10 8L14 12"
                          stroke="#2E2E38"
                          stroke-width="1.4"
                          stroke-linecap="round"
                          stroke-linejoin="round"/>
                  </g>
                </svg>
                <div class="text">There are no notifications.</div>
              </div>
              <!-- /알림 내용 없는 경우 -->
            </div>
          </div>
        </div>
      </div>
      <!-- /알림 영역 -->
    </b-row>

    <!--Detail modal start-->
    <b-modal size="lg"
             ref="modalUserInfo"
             header-class="detail-header"
             title="User Information"
             ok-only
             ok-variant="secondary"
             ok-title="Close"
             modal-class="popup-user-info"> <!-- size = xl, lg, sm -->
      <!-- user info 팝업 내 컨텐츠 신규 마크업 작업 -->
      <div class="form-user-info">
        <loading :active.sync="detailPopupLoading"
                 :can-cancel="false"
                 :is-full-page="false"></loading>
        <div class="form-list">
          <div class="form-wrap">
            <label for="userId">User ID</label>
            <div class="form-area">
              <div class="form-group">
                <input readonly
                       class="form-control"
                       name="userId"
                       v-model="user.userId">
              </div>
            </div>
          </div>
          <div class="form-wrap">
            <label for="userName">User Name</label>
            <div class="form-area">
              <div class="form-group">
                <input readonly
                       class="form-control"
                       name="userName"
                       v-model="user.userName">
              </div>
            </div>
          </div>
          <div class="form-wrap">
            <label for="mobile">Mobile</label>
            <div class="form-area">
              <div class="form-group">
                <input class="form-control"
                       name="mobile"
                       v-model="user.mobile">
              </div>
              <button type="button"
                      class="btn btn-success btn-primary"
                      @click="updateUserInfo('mobile')">Update
              </button>
            </div>
          </div>
          <div class="form-wrap">
            <label for="file-input">Profile Image</label>
            <div class="form-area">
              <div class="form-group">
                <b-form-file ref="user-file-input"
                             id="user-file-input"
                             @change="preview($event)"
                             v-model="user.file"
                             accept="image/*"
                             placeholder="Choose a file or drop it here"
                             drop-placeholder="Drop a file here"></b-form-file>
              </div>
              <button type="button"
                      class="btn btn-success btn-primary"
                      v-on:click="updateProfileImg()">Update
              </button>
              <!-- Profile image -->
              <figure>
                <span class="user-profile">
                  <!-- Custom image -->
                  <img v-if="user.profileImg && user.profileImg !== ''"
                    :src="user.profileImg.includes('blob')?
                          user.profileImg : 'data:image/' + user.profileImgName.substr(user.profileImgName.lastIndexOf('.')) + ';base64,' + user.profileImg"
                    alt="user profile">
                  <!-- /Custom image -->
                  <!-- Default image -->
                  <img v-else
                    src="../assets/images/icon_user.png"
                    alt="user profile">
                  <!-- /Default image -->
                </span>
                <figcaption class="text-center" style="font-size:0.8rem;">{{ user.profileImgName }}</figcaption>
              </figure>
              <!-- /Profile image -->
            </div>
          </div>
          <div class="form-wrap">
            <label for="preferredRole">Preferred Role</label>
            <div class="form-area">
              <div class="form-group"
                   v-if="roleList">
                <select class="form-control"
                        v-model="user.preferRole"
                        name="preferredRole">
                  <option value=""></option>
                  <option v-for="role in roleList"
                          :value="role"
                          :key="role">{{ role }}
                  </option>
                </select>
                <div class="alert-danger"
                     v-if="submitted && errors.has('preferredRole')">
                  {{ errors.first('preferredRole') }}
                </div>
              </div>
              <button type="button"
                      class="btn btn-success btn-primary"
                      v-on:click="updateUserInfo('role')">{{ 'Update' }}
              </button>
            </div>
          </div>
          <div class="form-wrap">
            <label for="password">Password</label>
            <div class="form-area">
              <div class="form-group">
                <input type="password"
                       class="form-control"
                       name="password"
                       v-model="user.password"
                       v-validate="'min:6|max:40'"
                       @keypress="showReEnterField(user.password)">
                <div class="alert-danger"
                     v-if="submitted && errors.has('password')">{{
                    errors.first('password')
                  }}
                </div>
              </div>
              <button type="button"
                      class="btn btn-success btn-primary"
                      v-on:click="updateUserInfo('password')">{{ 'Update' }}
              </button>
            </div>
          </div>
          <div class="form-wrap">
            <label for="rePassword">Password 확인</label>
            <div class="form-area">
              <div class="form-group mr-2 flex-grow-1">
                <input type="password"
                       class="form-control"
                       name="rePassword"
                       v-model="user.rePassword"
                       v-validate="'min:6|max:40'">
                <div class="alert-danger"
                     v-if="submitted && rePasswordErrorFlag">{{ rePasswordError }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </b-modal>
    <!--Detail modal end -->

  </b-container>
</template>

<script>
import Loading from "vue-loading-overlay";
import 'vue-loading-overlay/dist/vue-loading.css';
import SockJS from 'sockjs-client';
import Stomp from "stompjs"
import { Encrypt } from '@/utils.js'
import { WORKMAN_URL } from "@/const";
import vClickOutside from 'v-click-outside';

export default {
  name: 'TopBar',
  props: {
    project: {
      type: String,
      default: 'CHT'
    },
    hideToggle: {
      type: Boolean,
      default: false
    }
  },
  stompClient: null,
  components: { Loading },
  directives: {
    clickOutside: vClickOutside.directive
  },
  async created() {
    try {
      // Role이 Chatterer인 사용자만 notification 조회 or 웹소켓 연결
      if (this.hasAnyRole('Chatterer')) {
        this.openWebSocket();
        this.$store.dispatch('chatter/getNotifications');
        // this.getNotification();
        // this.notificationInterval = setInterval(this.getNotification, 20000);
      }

      // TobBar 최초 생성 시 모든 프로젝트 정보 조회 후 Vuex에 저장
      this.$store.dispatch('chatter/retrieveAllProjectInfo');
      this.getTodayOffUserIdList();
    } catch (e) {
      await this.showError(e);
    }
  },
  beforeDestroy() {
    clearInterval(this.notificationInterval);
  },
  data() {
    return {
      user: {
        tenantId: '',
        userId: '',
        userName: '',
        mobile:'',
        password: '',
        rePassword: '',
        preferRole: '',
        file: null
      },
      notificationInterval: null,
      successful: false,
      message: '',
      submitted: true,
      isHidden: true,
      detailPopupLoading: false,
      showDetailLoading: false,
      rePasswordVisible: false,
      // 드롭다운메뉴 노출 위해 추가
      isShowUserInfoMenu: true,

      roleList: [],
      beforeRole: '',

      rePasswordErrorFlag: false,
      rePasswordError: 'Password does not match.',

      //230607 추가
      notiLoading: false,
      chatList: [],

      notiPopoverVisible: false,
      socket: null,

      // 스크롤 시 topbar 스타일 변경
      isScroll: false,
    }
  },
  computed: {
    WORKMAN_URL() {
      return WORKMAN_URL
    },
    currentUser() {
      return this.$store.getters['auth/currentUser'];
    },
    notifications() {
      return this.$store.getters['chatter/getNotifications'];
    },
    notificationCount() {
      return this.$store.getters['chatter/getNotificationCount'];
    },
    notificationExists() {
      return this.notificationCount > 0;
    },
    filter() {
      return this.$store.getters['chatter/filter'];
    },
    isChatterListPage() {
      const path = this.$route.path;
      return path === '/chatter' || path === "/chatter/";
    }
  },
  methods: {

    // 웹소켓 연결
    openWebSocket() {

      this.socket = new SockJS(WORKMAN_URL + "chatterer", {transports: ['websocket']});

      // console.log(this.currentUser);
      this.stompClient = Stomp.over(this.socket);
      this.stompClient.debug = null;
      this.stompClient.connect({ Authorization: accessToken()}, () => {
        this.stompClient.subscribe('/user/queue/chatter/notification', (message)=>{
          this.$store.commit('chatter/mergeNotifications', JSON.parse(message.body));
        });
      })
    },
    preview(e) {
      let file = e.target.files[0];
      if(file == null) {
        this.user.profileImgName = '';
        this.user.profileImg = null;
        return;
      }
      this.user.profileImg = URL.createObjectURL(file);
      this.user.profileImgName = file.name;
    },
    showError(error) {
      if (error.status !== 401) {
        this.$store.commit('setMessage', error.message);
      }
    },
    isAdmin() {
      return this.hasAnyRole('Administrator');
    },
    redirect(event) {
      let role = event.target.innerText;

      if (['Supervisor', 'Administrator'].includes(role)) {
        this.pushRoute('/admin')
      } else if (['Operator'].includes(role)) {
        this.pushRoute('/dashboard');
      } else if (['Chatterer'].includes(role)) {
        this.pushRoute('/chatter');
      } else if (['Surveyor'].includes(role)) {
        this.pushRoute('/survey');
      } else if (['ESG'].includes(role)) {
        this.pushRoute('/esg');
      } else {
        this.pushRoute('/dashboard');
      }
    },
    goDashboard() {
      if (this.hasAnyRole('Supervisor')) {
        this.pushRoute('/admin');
      } else if (this.hasAnyRole('Surveyor')) {
        this.pushRoute('/survey');
      } else if (this.hasAnyRole("Chatterer")) {
        this.pushRoute('/chatter');
      } else {
        this.pushRoute('/dashboard');
      }
    },
    goSign() {
      if (this.$router.currentRoute.name === 'signup') {
        this.pushRoute('signin');
      } else if (this.$router.currentRoute.name === 'signin') {
        this.pushRoute('signup');
      } else {
        this.$store.dispatch('auth/logout');
        this.pushRoute('/signin');
      }
    },
    showSign() {
      if (this.$router.currentRoute.name === 'signup') {
        return 'Sign In';
      } else if (this.$router.currentRoute.name === 'signin') {
        return 'Sign Up';
      } else {
        return 'Sign Out';
      }
    },
    toggleSidebar() {
      this.isHidden = !this.isHidden;
      this.$parent.toggleSidebar();
    },
    showUserDetail() {
      if (this.user.tenantId === '') {
        let userInfo = this.currentUser;
        this.user.tenantId = userInfo.tenant;
        this.user.userId = userInfo.caller;
        this.user.userName = userInfo.userkorname;
        this.user.mobile = userInfo.mobile;
        this.user.preferRole = userInfo.preferRole;
        this.roleList = userInfo.roles;
        this.beforeRole = userInfo.preferRole;
      }
      this.user.file = null;
      this.user.profileImg = this.currentUser.profileImg;
      this.user.profileImgName = this.currentUser.profileImgName;
      this.$refs['modalUserInfo'].show();
    },
    showNotification() {
      this.retrieveChatList();
    },
    showReEnterField() {
      if (this.rePasswordVisible === false) {
        this.rePasswordVisible = true;
      }
    },
    async updateUserInfo(type) {

      this.submitted = true;
      this.detailPopupLoading = true;

      //let returnFlag = false;
      // Update confirmation
      let encrypted = '';

      const cloneObj = obj => JSON.parse(JSON.stringify(obj));
      let updateData = cloneObj(this.user);

      if (type === 'password') {
        if (updateData.password === '' || updateData.rePassword === '') {
          this.showMessage("패스워드를 입력해주세요.");
          this.detailPopupLoading = false;
          return;
        }
        if ((updateData.rePassword == null || updateData.rePassword === '') || updateData.rePassword.trim() !== updateData.password.trim()) {
          this.rePasswordErrorFlag = true;
          this.rePasswordError = 'Password does not match.'
          this.detailPopupLoading = false;
          return;
        }
        encrypted = Encrypt(updateData.password); //패스워드 암호화
      } else if (type === 'role') {
        if (updateData.preferRole === '') {
          await this.showMessage("Role을 선택해주세요.");
          this.detailPopupLoading = false;
          return;
        }
        if (this.beforeRole === updateData.preferRole) {
          await this.showMessage("Role이 동일합니다.");
          this.detailPopupLoading = false;
          return;
        }
      } else if (type == 'mobile') {
        const pattern = /^\d{11}$/;
        if(!updateData.mobile) {
          this.showMessage("번호를 입력해주세요.");
          return;
        } else if(!pattern.test(updateData.mobile)) {
          this.showMessage("숫자 11자리로 입력해주세요.");
          return;
        }
      }

      this.$validator.validate().then(async valid => {
        if (valid) {
          let params = {
            tenantId: updateData.tenantId,
            userId: updateData.userId,
            userName: updateData.userName,
            preferRole: updateData.preferRole,
            password: encrypted,
            mobile: updateData.mobile
          };

          try {
            await axios.post('auth/updateUserInfo', params, {
              headers: {
                'Accept': 'application/json',
                'Authorization': accessToken()
              },
              responseType: "blob"
            });

            await this.showMessage('정상적으로 변경되었습니다.');
            this.user.password = '';
            this.user.rePassword = '';
            this.beforeRole = updateData.preferRole;
            this.mobile = updateData.mobile;
          } catch (error) {
            this.showError(error.message);
          } finally {
            this.detailPopupLoading = false;
            this.submitted = false;
          }
        }
      });
    },
    // async getNotification() {
    //   try {
    //     const response = await axios.get("chatter/notifications", {
    //       headers: {
    //         Authorization: accessToken(),
    //         Accept: "application/json"
    //       }
    //     });
    //     this.$store.commit('chatter/setNotifications', response.data);
    //   } catch (error) {
    //     console.log(error);
    //   }
    // },
    async retrieveChatList() {
      this.notiLoading = true;
      // Set parameters
      this.chatList = [];

      let params = {};

      if(!this.isChatterListPage) {
        params.hierarchy = false;
        params.retrieveType = "UPDATED";
      } else {
        this.$store.commit('chatter/resetFilter');
        this.$store.commit('chatter/setRetrieveType', "UPDATED");
        this.filter.hierarchy = false;
        params = {...this.filter}
      }

      // Load chats
      try {
        let response = await axios.post('/chatter/retrieveChatterList', params, {
          headers: {
            Authorization: accessToken()
          }
        });

        const status = response.data.status;
        if(status === "200") {
          // Commit the newly fetched chatters to Vuex
          const body = response.data.body;
          this.chatList = body.list;
          this.chatTotal = body.total;
          
        } else {
          this.$bvToast.toast(response.data.message, 
          {
            title: `Notification`,
            toaster: "b-toaster-bottom-center",
            solid: true,
            appendToast: false,
            autoHideDelay: 500,
            variant: "danger"
          });
        }
        // Sort chatList in descending order
      } catch (error) {
        await this.showError(error);
      } finally {
        this.notiLoading = false;
      }
    },
    showChatDetail(chatId) {
      this.pushRoute({ name: "chatDetail", params: { id: chatId } });
      this.$refs['modalNotification'].hide();
    },
    async updateProfileImg() {
      let data = new FormData();
      data.append("file", this.user.file);
      await axios.post("auth/updateProfileImg", data, {
        headers: {
          Accept: "application/json",
          Authorization: accessToken(),
          "Content-Type": "multipart/form-data",
        },
        responseType: "json"
      }).then(response => {
        if (response.data) {
          // 정보 수정 Modal update
          this.user.profileImg = response.data.profileImg;
          this.user.profileImgName = response.data.profileImgName;
          // store user update
          this.$store.commit("auth/setUserProfile", response.data);
          this.showMessage('정상적으로 변경되었습니다.');
        }
      }).catch((error) => {
        this.showError(error);
      });
    },
     // 사용자 메뉴얼 조회
    async showUserManual() {
      const routeUrl = this.$router.resolve({ name: "pdf-view", params: { fileName: 'memo-pms-usr-manual.pdf' } }).href;
      window.open(routeUrl, '_blank');
      // this.pushRoute();
    },
    // 드롭다운메뉴 노출 위해 추가
    showUserInfoMenu() {
      this.isShowUserInfoMenu = !this.isShowUserInfoMenu;
    },
    closeUserInfoMenuPopOver() {
      this.isShowUserInfoMenu = true;
    },
    closeNotiPopOver() {
      this.notiPopoverVisible = false;
    },
    async openNotiPopover() {
      if(!this.notificationExists) return;
      try {
        // 24-06-24 read 상태인 알림 삭제
        await this.clearReadNotifications();

        await this.retrieveChatList();
        //현재 사용자가 접속한 url 정보
        let url=window.location.pathname;
        //현재 사용자가 접속한 화면이 MeMO List인 경우 -> 알림 팝업창 대신 화면 list로 알림 내역 보여줌
        if(this.isChatterListPage){
          this.$store.commit('chatter/resetChats');
          this.$store.commit('chatter/setChats', this.chatList);
          this.$store.commit('chatter/setTotal', this.chatTotal);
          //filter 관련 정보 초기화
          this.$store.commit('chatter/setFilterOccupied',false);
          //status bar 활성화(=filter 비활성화)
          this.$store.commit('chatter/setOccupied',true);
          this.$store.commit('chatter/setPage', 1);
          //searchOptionsLabel 문구 설정
          this.$store.commit('chatter/setSearchOptionsLabel','My Notifications');
        } else {
          this.notiPopoverVisible = !this.notiPopoverVisible;
        }
      } catch(e) {
        console.log(e);
      }
    },
    convertStatusToTitleCase(status) {
      return status.toLowerCase()
        .split('_')
        .map(word => {
          return word.slice(0, 1).toUpperCase() + word.slice(1)
        })
        .join(' ')
    },
    convertStatusToKebabCase(status) {
      return this.convertStatusToTitleCase(status).toLowerCase().replace(/ /g, '-')
    },
    // 스크롤 시 topbar 스타일 변경
    topbarFixed() {
      const scrollPosition = document.documentElement.scrollTop;
      if(scrollPosition > 0) this.isScroll = true;
      else this.isScroll = false;
    },
    //금일 휴가인 사람들의 userId 목록 가져옴
    async getTodayOffUserIdList () {
      try {
        let params = {};
        //금일 휴가인 모든 사람들을 가져오기 위함
        const today = new Date();
        const year = today.getFullYear();
        const month = String(today.getMonth() + 1).padStart(2, '0'); // 월은 0부터 시작하므로 1을 더합니다.
        const day = String(today.getDate()).padStart(2, '0');
        params.pageSize = 999;
        //오늘 날짜
        params.date = `${year}-${month}-${day}`;
        const response = await axios.get("chatter/retrieveDayOff", {
          params,
          headers: {
            'Accept': 'application/json',
            'Authorization': accessToken()
          }
        });
        this.$store.commit('chatter/setTodayOffUserIdList', response.data.list.map(obj => obj.userId));
      } catch (error) {
        console.log(error)
      }
    },
    async clearReadNotifications() {
      const response = await axios.post('/chatter/clearReadNotifications', {}, {
        headers: {
          'Accept': 'application/json',
          'Authorization': accessToken()
        }
      })

      const status = response.data.status;
      if (status !== "200") {
        const message = response.data.message;
        throw new Error(message);
      }
    }
  },
  mounted() {
    window.addEventListener('scroll', this.topbarFixed)
  },
  beforeUnmount() {
    window.removeEventListener('scroll', this.topbarFixed)
  },
  
}
</script>

<style>
/* user info 팝업 */
.popup-user-info.modal.show .modal-dialog {
    margin: 0 auto;
    height: 100vh;
    display: flex;
    flex-direction: column;
    justify-content: center;
}

.popup-user-info .modal-content {
    border-radius: 20px;
}

.popup-user-info .modal-header {
    align-items: center;
    padding: 2.083vw 2.666rem 1.041vw;
    border-radius: 20px 20px 0 0;
    border-bottom: 0px;
}

.popup-user-info .modal-title {
    margin-bottom: 0 !important;
    color: #2E2E38;
    font-family: 'NanumGothic';
    font-size: 24px;
    font-weight: 700;
    line-height: 150%;
}

.popup-user-info .modal-header .close {
    width: 30px;
    height: 30px;
    margin: 0;
    font-size: 0;
    background: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 30 30" fill="none"><path d="M22.5 22.5L7.5 7.5" stroke="%232E2E38" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/><path d="M22.5 7.5L7.5 22.5" stroke="%232E2E38" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/></svg>') center no-repeat;
}

.popup-user-info .modal-body {
    padding: 1.041vw 2.666rem;
}

.popup-user-info .modal-body .form-user-info .form-list {
    display: flex;
    flex-direction: column;
    gap: 1vw 0;
}

.popup-user-info .form-user-info .form-list label {
    padding-left: 0.4rem;
    margin-bottom: 0.53rem;
    color: #2E2E38;
    font-family: 'NanumGothic';
    font-size: 14px;
    font-weight: 700;
    line-height: 150%;
}

.popup-user-info .form-user-info .form-area {
    display: flex;
    align-items: center;
    gap: 0 0.8rem;
}

.popup-user-info .form-user-info .form-area .form-group {
    flex: 1 0;
}

.popup-user-info .form-user-info .custom-file {
    height: 40px;
}

.popup-user-info .form-user-info .custom-file-input {
    height: 100%;
}

.popup-user-info .form-user-info .custom-file-input ~ .custom-file-label[data-browse]::after {
    content: none;
}

.popup-user-info .form-user-info .custom-file-input.focus {
    border: none;
    box-shadow: none;
}

.popup-user-info .form-user-info .form-list .custom-file-label {
    height: 100%;
    padding: 0.533rem 1.066rem;
    margin-bottom: 0;
    border-radius: 10px;
    border: 1px solid #E7E7EE;
    background-color: #F6F6FA;
}

.popup-user-info .form-user-info .custom-file-label span {
    color: #747480;
    font-family: 'NanumGothic';
    font-size: 16px;
    font-weight: 400;
    line-height: 150%;
}

.popup-user-info .modal-body input.form-control {
    padding: 0.533rem 0.8rem 0.533rem 1.066rem;
    height: 2.666rem !important;
    border-radius: 10px !important;
    border: 1px solid #E7E7EE;
    background-color: #F6F6FA;
    font-family: 'NanumGothic';
    color: #2E2E38;
    font-size: 16px;
    font-weight: 400;
    line-height: 150% !important;
}

.popup-user-info .modal-body input.form-control:read-only {
    background-color: #E0E0E7;
    color: #747480;
}

.popup-user-info .modal-body select.form-control {
    -o-appearance: none;
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
    padding: 0.533rem 0.8rem 0.533rem 1.066rem;
    height: 2.666rem;
    border-radius: 10px;
    border: 1px solid #E7E7EE;
    background-color: #F6F6FA;
    background-image: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none"><path d="M15.834 7.5L10.0007 13.3333L4.16732 7.5" stroke="%232E2E38" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>');
    background-position: calc(100% - 12px) 9px;
    background-size: 20px 20px;
    background-repeat: no-repeat;
    font-family: 'NanumGothic';
    color: #2E2E38;
    font-size: 16px;
    font-weight: 400;
    line-height: 150%;
}

.popup-user-info .modal-footer {
    justify-content: center;
    padding: 1.562vw 2.666rem 2.604vw;
    border-top: 0px;
    border-radius: 0 0 20px 20px;
}

.popup-user-info .btn {
    border-radius: 10px;
    font-family: 'NanumGothic';
    font-size: 14px;
    font-weight: 500;
    line-height: 150%;
}

.popup-user-info .btn-primary {
    width: 148px;
    height: 40px;
    background-color: #2E2E38;
    color: #FFE600;
    border-color: transparent;
}

.popup-user-info .btn-primary:hover {
    color: #FFE600;
    background-color: #0D0D17;
    border-color: transparent;
}

.popup-user-info .btn-primary.disabled,
.popup-user-info .btn-primary:disabled {
    color: #9C9CA8;
    background-color: #C4C4CD;
    border-color: transparent;
}

.popup-user-info .modal-footer .btn-secondary {
    width: 146px;
    height: 40px;
    margin: 0;
    border-radius: 10px;
    background: #747480;
    color: #fff;
    border-radius: 10px;
    font-family: 'NanumGothic';
    font-size: 14px;
    font-weight: 500;
    line-height: 150%;
}

.popup-user-info .modal-footer .btn-secondary:hover {
    background-color: #565662;
}

.popup-user-info .modal-footer .btn-secondary.disabled,
.popup-user-info .modal-footer .btn-secondary:disabled {
    color: #9C9CA8;
    background-color: #C4C4CD;
    border-color: transparent;
}
</style>

<style scoped>
/* import font */
@import url('https://hangeul.pstatic.net/hangeul_static/css/nanum-gothic.css');

#sysname a {
    display: block;
}

.full .topheader {
    width: 100%;
}

.topheader {
    position: fixed;
    width: 83.334%;
    padding: 2rem 4.1666vw 1.333rem;
    background-color: transparent;
    z-index: 100;
    transition: all ease-in-out 0.3s;
    box-shadow: none;
    z-index: 1000;
}

.topheader.fixed {
    padding: 0.666rem 3.125vw;
    background-color: #FFF;
    border-bottom: 1px solid #DDDDE3;
    box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.05);
}

#topbar {
    height: auto;
    max-height: 9.333rem;
    margin: 0;
    gap: 0.666rem 0;
    padding: 0;
    align-items: center;
    background-color: transparent;
}

.sidebar-toggler {
    position: fixed;
    top: max(3.333rem, 3.125vw);
    left: 1.25vw;
    display: block;
    width: 30px;
    height: 30px;
    background-image: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 40 40" fill="none"><path d="M15 33.3337L15 6.66699" stroke="%23C0C0C3" stroke-width="3.33333" stroke-linecap="round" stroke-linejoin="round"/><path d="M33.3327 31.667V8.33366C33.3327 7.41319 32.5865 6.66699 31.666 6.66699L8.33268 6.66699C7.41221 6.66699 6.66602 7.41318 6.66602 8.33366L6.66602 31.667C6.66602 32.5875 7.41221 33.3337 8.33268 33.3337H31.666C32.5865 33.3337 33.3327 32.5875 33.3327 31.667Z" stroke="%23C0C0C3" stroke-width="3.33333" stroke-linecap="round" stroke-linejoin="round"/><rect width="8" height="26" transform="matrix(-1 0 0 1 15 7)" fill="%23C0C0C3"/></svg>');
    background-size: cover;
    background-repeat: no-repeat;
    z-index: 1000;
}

.sidebar-toggler.fold {
    background-image: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 40 40" fill="none"><path d="M15 33.3337L15 6.66699" stroke="%232E2E38" stroke-width="3.33333" stroke-linecap="round" stroke-linejoin="round"/><path d="M33.3327 31.667V8.33366C33.3327 7.41319 32.5865 6.66699 31.666 6.66699L8.33268 6.66699C7.41221 6.66699 6.66602 7.41318 6.66602 8.33366L6.66602 31.667C6.66602 32.5875 7.41221 33.3337 8.33268 33.3337H31.666C32.5865 33.3337 33.3327 32.5875 33.3327 31.667Z" stroke="%232E2E38" stroke-width="3.33333" stroke-linecap="round" stroke-linejoin="round"/><rect width="17" height="26" transform="matrix(-1 0 0 1 33 7)" fill="%232E2E38"/></svg>');
}

.user-info-area {
    display: flex;
    align-items: center;
    margin-right: 1.26rem;
}

.user-detail {
    text-decoration: none;
    color: #2E2E38;
    font-family: 'NanumGothic';
    font-size: 18px;
    font-weight: 400;
    line-height: 150%;
}

.fixed .user-profile {
  border: 1px solid #DDDDE3;
}

.user-profile {
    position: relative;
    display: inline-block;
    width: 40px;
    height: 40px;
    margin-right: 0.93rem;
    border-radius: 50%;
    overflow: hidden;
}

.user-profile img {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 100%;
    height: 100%;
    object-fit: cover;
}

.info-menu-area {
    position: relative;
}

.btn-user-info {
    display: block;
    width: 24px;
    height: 24px;
    border: none;
    background: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"><path d="M15 11L12 14L9 11" stroke="%232E2E38" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>') center/cover no-repeat transparent;
}

.info-menu-area .user-info-menu {
    position: absolute;
    top: 44px;
    left: 50%;
    transform: translateX(-50%);
    width: 140px;
    height: 80px;
    background-color: #fff;
    border-radius: 10px;
    z-index: 1000;
    box-shadow: 0px 14px 30px 0px rgba(0, 0, 0, 0.30);
}

.info-menu-area .user-info-menu::after {
    content: '';
    display: block;
    position: absolute;
    left: 50%;
    top: -12px;
    transform: translateX(-50%);
    width: 14px;
    height: 12px;
    border-top: 0px solid transparent;
    border-bottom: 12px solid #fff;
    border-left: 7px solid transparent;
    border-right: 7px solid transparent;
}

.info-menu-area .user-info-menu .menu {
    display: block;
    height: 40px;
    padding: 4px;
}

.info-menu-area .user-info-menu .menu:first-child {
    border-radius: 10px 10px 0 0;
}

.info-menu-area .user-info-menu .menu:last-child {
    background: #E7E7EE;
    border-radius: 0 0 10px 10px;
}

.info-menu-area .user-info-menu .menu a {
    display: block;
    width: 100%;
    height: 100%;
    text-align: center;
    line-height: 32px;
    color: #2E2E38;
    text-align: center;
    font-family: 'NanumGothic';
    font-size: 14px;
    font-weight: 500;
    border-radius: 10px 10px 4px 4px;
}

.info-menu-area .user-info-menu .menu #sign a {
    padding: 0;
    border-color: unset;
    background-color: #E7E7EE;
    color: #2E2E38;
    font-weight: 500;
    border-radius: 4px 4px 10px 10px;
}

.info-menu-area .user-info-menu .menu a:hover {
    background: rgba(46, 46, 56, 0.06);
}

.info-menu-area .user-info-menu .menu #sign a:hover {
    background: rgba(46, 46, 56, 0.08);
}

.badge-project {
    padding: 6px 14px;
    border-radius: 40px;
    background: #747480;
    color: #FFF;
    font-family: 'NanumGothic';
    font-size: 14px;
    font-weight: 400;
    line-height: 150%;
}

.badge-project:hover {
    color: #fff;
}

/* 알림 영역 */
.notify-wrap {
    position: relative;
    font-family: 'NanumGothic';
    /* color: #2E2E38; */
}

.notify-area {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 0 1.333rem;
    height: 50px;
    padding: 0.533rem 1.6rem 0.533rem 1.066rem;
    border-radius: 40px;
    background-color: #E4E4EC;
    border: 1px solid transparent;
    cursor: pointer;
}

.notify-area.active {
    background-color: #E7E7EE;
    border: 1px solid #2E2E38;
}

.notify-area:hover {
    background-color: #DDDDE3;
}

.topheader.fixed .notify-area {
    background-color: #FFF;
    border: 1px solid #DDDDE3;
}

.topheader.fixed .notify-area.active,
.topheader.fixed .notify-area:hover {
    border: 1px solid #2E2E38;
}

.notify-area .btn-notify {
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
    width: 32px;
    height: 32px;
    padding: 0;
    border-radius: 90px;
    border: none;
    background-color: transparent;
}

.notify-area .btn-notify::before {
    content: '';
    display: block;
    position: absolute;
    top: 50%;
    left: 50%;
    width: 28px;
    height: 28px;
    background-image: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 28 28" fill="none"><path d="M17.5 19.8333H10.5V21C10.5 22.933 12.067 24.5 14 24.5C15.933 24.5 17.5 22.933 17.5 21V19.8333Z" fill="%232E2E38"/><path d="M5.83329 19.8333H22.1666C22.811 19.8333 23.3333 19.311 23.3333 18.6666V17.9832C23.3333 17.6738 23.2104 17.3771 22.9916 17.1583L22.3956 16.5623C22.249 16.4156 22.1666 16.2168 22.1666 16.0094V11.6666C22.1666 7.15629 18.5103 3.49994 13.9999 3.49995C9.48962 3.49997 5.83329 7.1563 5.83329 11.6666V16.0095C5.83329 16.2168 5.75092 16.4157 5.6043 16.5623L5.00833 17.1583C4.78954 17.3771 4.66663 17.6738 4.66663 17.9832V18.6666C4.66663 19.311 5.18896 19.8333 5.83329 19.8333Z" stroke="%232E2E38" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>');
    background-repeat: no-repeat;
    transform: translate(-50%, -50%);
}

.notify-area .btn-notify.alert {
    margin-bottom: 0;
}

.notify-area .btn-notify.alert::before {
    background-image: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 28 28" fill="none"><path d="M17.5 19.8333H10.5V21C10.5 22.933 12.067 24.5 14 24.5C15.933 24.5 17.5 22.933 17.5 21V19.8333Z" fill="%232E2E38"/><path d="M5.83334 19.8333H22.1667C22.811 19.8333 23.3333 19.311 23.3333 18.6666V17.9832C23.3333 17.6738 23.2104 17.3771 22.9916 17.1583L22.3957 16.5623C22.249 16.4156 22.1667 16.2168 22.1667 16.0094V11.6666C22.1667 7.15629 18.5103 3.49994 14 3.49995C9.48967 3.49997 5.83334 7.1563 5.83334 11.6666V16.0095C5.83334 16.2168 5.75097 16.4157 5.60434 16.5623L5.00838 17.1583C4.78959 17.3771 4.66667 17.6738 4.66667 17.9832V18.6666C4.66667 19.311 5.18901 19.8333 5.83334 19.8333Z" stroke="%232E2E38" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/><circle cx="20.5333" cy="6.53334" r="3.73333" fill="%23FF0000"/></svg>');
}

.notify-area .notify-list-wrap {
    display: flex;
    align-items: center;
    gap: 0 1.333rem;
}

.notify-area .notify-list {
    display: flex;
    align-items: center;
    position: relative;
    height: 33px;
    font-size: 14px;
    color: #2E2E38;
}

.notify-area .notify-list::after {
    content: '';
    display: block;
    position: absolute;
    top: 50%;
    right: -10px;
    width: 1px;
    height: 14px;
    background-color: #C4C4CD;
    transform: translateY(-50%);
}

.notify-area .notify-list:last-child::after {
    display: none;
}

.notify-area .notify-list .notify-item {
    height: 100%;
    padding: 0 1.066rem;
    border: none;
    border-radius: 90px;
    background-color: #E4E4EC;
    font-weight: 500;
    color: #2E2E38;
}

.notify-area .notify-list .notify-item .num {
    margin-left: 0.666rem;
    font-weight: 700;
}

.notify-contents-wrap {
    position: absolute;
    top: 66px;
    /* left: 0; */
    right:0;
    z-index: 1000;
    width: 60vh;
}

.notify-contents-wrap::after {
    content: '';
    display: block;
    width: 0;
    height: 0;
    position: absolute;
    top: -1.8rem;
    right: 4.0rem;
    border-bottom: 15px solid #fff;
    border-top: 15px solid transparent;
    border-left: 10px solid transparent;
    border-right: 10px solid transparent;
}

.notify-contents-wrap.all-noti::after {
    right: 4.0rem;
}

.notify-contents-wrap.creator::after {
    left: 6.9333rem;
}

.notify-contents-wrap.assign::after {
    left: 15.2666rem;
}

.notify-contents-wrap.watcher::after {
    left: 23.8rem;
}

.notify-contents-wrap .notify-contents-area {
    width: 100%;
    min-height: 100px;
    max-height: 600px;
    padding: 1.6rem 1.6rem 0;
    border-radius: 10px;
    overflow-y: auto;
    box-shadow: 0px 14px 30px 0px rgba(0, 0, 0, 0.30);
    background-color: #fff;
}

.notify-contents-wrap .notify-contents-area .notify-contents {
    position: relative;
    padding: 2rem 0;
}

.notify-contents-wrap .notify-contents:first-child {
    padding-top: 0;
}

.notify-contents-wrap .notify-contents:last-child {
    padding-bottom: 1.6rem;
}

.notify-contents-wrap .notify-contents::after {
    content: '';
    display: block;
    position: absolute;
    bottom: 0;
    left: -1.6rem;
    width: calc(100% + 48px);
    height: 1px;
    background-color: #dddde3;
}

.notify-contents-wrap .notify-contents:last-child::after {
    display: none;
}

.notify-contents-wrap .notify-contents .title {
    margin-bottom: 1.333rem;
    font-size: 16px;
    font-weight: 700;
}

/* 알림 없는 경우 */
.notify-contents-wrap .notify-contents.no-notify {
    display: flex;
    align-items: center;
    justify-content: center;
    padding-top: 0.9333rem;
}

.notify-contents-wrap .notify-contents.no-notify .text-wrap {
    display: flex;
    align-items: center;
}

.notify-contents-wrap .notify-contents.no-notify .text-wrap .text {
    margin-left: 0.2666rem;
    color: #2E2E38;
    font-size: 14px;
    font-weight: 500;
    opacity: 0.5;
}

.notify-contents-wrap .notify-box .box-area {
    padding: 2rem 0;
    border-bottom: 1px solid #dddde3;
}

.notify-contents-wrap .notify-box .box-area:first-of-type {
    padding-top: 0;
}

.notify-contents-wrap .notify-box .box-area:last-child {
    padding-bottom: 0;
    border-bottom: 0;
}

/* tag default style */
.notify-contents-wrap .notify-box .tag {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100px;
    height: 29px;
    margin-bottom: 0.666rem;
    border-radius: 38px;
    background-color: #F6F6FA;
    font-size: 14px;
    font-weight: 500;
}

/* tag bg orange style */
.notify-contents-wrap .notify-box .tag.to-do {
    background-color: #F6F6FA;
    color: #2E2E38;
}

.notify-contents-wrap .notify-box .tag.in-progress {
    background-color: #F5ECD6;
    color: #FF5C00;
}

.notify-contents-wrap .notify-box .tag.in-progress-red {
    background-color: #F5D6D6;
    color: #F00;
}

.notify-contents-wrap .notify-box .tag.done {
    background-color: #CFDDFF;
    color: #1755CC;
}

.notify-contents-wrap .notify-box .tag.closed {
    background-color: #D7F5D6;
    color: #168D4C;
}

.notify-contents-wrap .notify-box .text-wrap {
    text-decoration: none;
    outline: none;
    color: #2E2E38;
}

.notify-contents-wrap .notify-box .subject-wrap {
    display: flex;
    gap: 0 1.133rem;
    margin-block: 0.4rem;
    font-weight: 500;
}

.notify-contents-wrap .notify-box .subject-wrap .subject {
    position: relative;
    font-weight: 700;
}

.notify-contents-wrap .notify-box .text-wrap:hover .subject-wrap .subject {
    text-decoration: underline;
}

.notify-contents-wrap .notify-box .subject-wrap .subject::before {
    content: '';
    display: block;
    position: absolute;
    top: 0.4rem;
    left: -0.6rem;
    width: 1px;
    height: 10px;
    background-color: #2E2E38;
}

/* scrollbar */
.notify-custom-scrollbar::-webkit-scrollbar {
    width: 20px;
    border-top: 24px solid transparent;
    border-bottom: 24px solid transparent;
    border-right: 14px solid transparent;
    background-clip: padding-box;
}

.notify-custom-scrollbar::-webkit-scrollbar-track {
    width: 6px;
    background-color: #F6F6FA;
    border-top: 24px solid transparent;
    border-bottom: 24px solid transparent;
    border-right: 14px solid transparent;
    background-clip: padding-box;
}

.notify-custom-scrollbar::-webkit-scrollbar-thumb {
    width: 100%;
    background-color: #C4C4CD;
    border-top: 24px solid transparent;
    border-bottom: 24px solid transparent;
    border-right: 14px solid transparent;
    background-clip: padding-box;
}

.table th, td {
    margin: 0px;
    vertical-align: middle !important;
}

.form-control, .form-group {
    margin: 0px;
}
.form-user-info figure {
  margin: 0;
}
.form-wrap .user-profile {
  width: 80px;
  height: 80px;
}

.manual img{
  width: 30px;
  height: 20px;
}
.manual button {
  background: none;
  border: none;
  padding: 0;
  cursor: pointer;
  margin-right: 30px;
}
</style>